import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { TipForm } from '../forms'
import { Dashboard } from '../layouts'
import axios from '../plugins/axios'

const styles = theme => ({
    //
})

class TipUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Tips',
            key: shortid.generate(),
            name: '',
            body: ''
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/tips/${id}`)

            this.setState({
                key: shortid.generate(),
                name: data.name,
                body: data.body
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            body
        } = this.state
        const { match } = this.props
        const { id } = match.params

        return (
            <Dashboard title={title}>
                <TipForm
                    key={key}
                    path={`tips/${id}`}
                    method="put"
                    name={name}
                    body={body}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(TipUpdate)
